// supabaseClient.js
import { createClient } from '@supabase/supabase-js';

const supabaseUrl = 'https://vlbypddrxgqzwmcdoxvp.supabase.co';
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY || 'sb_publishable_OFz6YpGKRHYtsU8RMjxuLA_5XpcWdYC';

export const supabase = createClient(supabaseUrl, supabaseAnonKey);